import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import majice from "../img/mrlewhite.png";

function PrijavaSaPost() {
  return (

    <Link to="/prijavasapl">
    <div className="menu-card">
        <div className="text majice">
          <h2>Rezerviraj mjesto + Merch na ulazu</h2>
      <p>Prijavi automobil uz plaćanje online</p>
      <p>Na ulazu te čeka novi merch u tvojoj veličini</p>
      
        <Link className="majice" to="/prijavasapl">
            <img src={majice} className="logo" alt="logo" height="280" />
        </Link>
        <p>+10 € na cijenu kotizacije</p>
        </div>
    </div>
</Link>
  );
}

export default PrijavaSaPost;